import {AfterViewInit, Component, ElementRef, Input} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'lib-show-password',
    templateUrl: './show-password.component.html',
    styleUrls: ['./show-password.component.css'],
    imports: [MatIcon]
})
export class ShowPasswordComponent implements AfterViewInit{
    @Input() inputRef: any;

    ngAfterViewInit() {
        if (this.inputRef) {
            console.log(this.inputRef.type)
            const valeurInput = this.inputRef.nativeElement;
        }
    }
}
